import Vue from "vue";
import VueRouter from "vue-router";

import News from "../views/News.vue";
import Events from "../views/Events.vue";
import Newsletters from "../views/Newsletters.vue";
import SchoolSetup from "../views/SchoolSetup.vue";
import School from "../views/School.vue";
import Settings from "../views/Settings.vue";
import Home from "../views/Home.vue";
import store from "../store/index.js";
import { getCookie, setCookie, deleteCookie } from "../mixins/cookies";
import Enrolment from "@/views/Enrolment.vue";
import LearningResources from "@/views/LearningResources.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/news",
    name: "News",
    component: News,
    meta: {
      title: "news.title",
      showFilter: false,
      redirectWithoutSchools: true,
      showNavigation: true,
      showNotifications: true
    }
  },
  {
    path: "/essentials",
    name: "School Essentials",
    meta: {
      title: "schoolEssentials.title",
      showFilter: true,
      redirectWithoutSchools: true,
      showNavigation: true,
      showNotifications: false
    }
  },
  {
    path: "/events",
    name: "Calendar",
    component: Events,
    meta: {
      title: "calendar.title",
      showFilter: true,
      redirectWithoutSchools: true,
      showNavigation: true,
      showNotifications: true
    }
  },
  {
    path: "/events/:id",
    name: "Calendar",
    component: Events,
    meta: {
      title: "calendar.title",
      showFilter: true,
      redirectWithoutSchools: true,
      showNavigation: true,
      showNotifications: true
    }
  },
  {
    path: "/newsletters",
    name: "Newsletters",
    component: Newsletters,
    meta: {
      title: "newsletters.title",
      showFilter: true,
      redirectWithoutSchools: true,
      showNavigation: true,
      showNotifications: true
    }
  },
  {
    path: "/enrolment",
    name: "Enrolment",
    component: Enrolment,
    meta: {
      title: "enrolment.title",
      showFilter: false,
      showNavigation: true,
      redirectWithoutSchools: true,
      showNotifications: true
    }
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: {
      title: "settings.title",
      showFilter: false,
      redirectWithoutSchools: true,
      showNavigation: true,
      showNotifications: true
    }
  },
  {
    path: "/school-setup",
    name: "Welcome",
    component: SchoolSetup,
    meta: {
      title: "schoolSetup.title",
      showFilter: false,
      redirectWithoutSchools: false,
      showNavigation: false,
      showNotifications: false
    }
  },
  {
    path: "/school-setup/:id",
    name: "Welcome",
    component: SchoolSetup,
    meta: {
      title: "schoolSetup.title",
      showFilter: false,
      redirectWithoutSchools: false,
      showNavigation: false,
      showNotifications: false
    }
  },
  {
    path: "/school/:id",
    name: "My schools",
    component: School,
    meta: {
      title: "mySchool.title",
      showFilter: false,
      redirectWithoutSchools: true,
      showNavigation: true,
      showSwitcher: true,
      showNotifications: true
    }
  },
  {
    path: "/news/:id",
    name: "News",
    component: News,
    meta: {
      title: "news.title",
      showFilter: false,
      redirectWithoutSchools: true,
      showNavigation: true,
      showNotifications: true
    }
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "home.title",
      showFilter: false,
      redirectWithoutSchools: true,
      showNavigation: false,
      showNotifications: true
    }
  },
  {
    path: "/learning-resources",
    name: "Learning resources",
    component: LearningResources,
    meta: {
      title: "learningResources.title",
      showFilter: false,
      redirectWithoutSchools: true,
      showNavigation: true,
      showNotifications: true
    }
  },
  {
    path: "/:catchAll(.*)",
    name: "Home",
    component: Home,
    meta: {
      title: "home.title",
      showFilter: false,
      redirectWithoutSchools: true,
      showNavigation: false,
      showNotifications: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior() {
    return { y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  let deeplinkType = getCookie("deeplinkType");
  let deeplinkUrl = getCookie("deeplinkUrl");
  let freshStart = getCookie("freshInstall");

  if (freshStart === "true") {
    setCookie("freshInstall", "false", 3650);
    store.dispatch("resetApp");
  }

  if (
    store.getters.mySchools.length === 0 &&
    to.meta.redirectWithoutSchools &&
    !deeplinkType
  ) {
    next("/school-setup");
  } else if (store.getters.mySchools.length === 0 && deeplinkType) {
    if (deeplinkType === "NEWS") {
      deleteCookie("deeplinkType");
      next(`school-setup/${encodeURIComponent(deeplinkUrl)}`);
    } else {
      deleteCookie("deeplinkType");
      next("/school-setup");
    }
  } else if (deeplinkType) {
    deleteCookie("deeplinkType");
    switch (deeplinkType) {
      case "NEWS":
        next(`news/${encodeURIComponent(deeplinkUrl)}`);
        break;
      case "NEWSLETTER":
        next("newsletters");
        break;
      case "EVENT":
        if (deeplinkUrl) {
          next(`events/${encodeURIComponent(deeplinkUrl)}`);
        } else {
          next("events");
        }
        break;
      case "SCHOOLUPDATES":
        next(`events/${encodeURIComponent(deeplinkUrl)}`);
        break;
      case "SCHOOL":
        next(`/school/${deeplinkUrl}`);
        break;
      case "ENROLMENT":
        next("enrolment");
        break;
      case "LEARNINGRESOURCES":
        next(`/learning-resources`);
        break;
      case "HOME":
        next("");
        break;
      default:
        next("");
    }
  } else {
    next();
  }
});

export default router;
